// extracted by mini-css-extract-plugin
export default {"category_a_card":"CategoryACard_category_a_card__CZGLv"};